<template>
    <a-switch :checked="checked" @update:checked="onUpdateChecked"/>
</template>

<script>
import {computed, watch, toRefs} from "vue";

export default {
    name: "SwitchInput",
    emits: ["update:value"],
    props: {
        value: {
            type: [String, Number],
        },
        checkedValue: {
            type: [String, Number],
            default: 1,
        },
        uncheckedValue: {
            type: [String, Number],
            default: 0,
        },
    },
    setup(props, {emit}) {
        const checked = computed(() => {
            return props.value === props.checkedValue;
        });
        const {value} = toRefs(props);
        watch(
            value,
            (value) => {
                emit("update:value", value);
            },
            {immediate: true},
        );
        const onUpdateChecked = (checked) => {
            let value = checked ? props.checkedValue : props.uncheckedValue;
            emit("update:value", value);
        };
        return {
            checked,
            onUpdateChecked,
        };
    },
};
</script>

<style scoped>
</style>
